export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Raskh",
  "alternateName": "رسخ",
  "url": "https://raskh.app",
  "logo": "https://raskh.app/logo512.png",
  "sameAs": [
    "https://twitter.com/raskhapp",
    "https://www.tiktok.com/@raskhapp"
  ],
  "foundingDate": "2024"
};
